import React, { useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { toast } from 'react-hot-toast';
import { baseUrl } from '../../../services/config'
import { Button, message, Space } from 'antd';
import { SendNotifaction } from '../../../services/SendNotifaction';
const RemoveUserModal = ({
    HideModal,
    visible,
    msg,
    title,
    onButtonClick,
    loading
}) => {




    return (
        <>
            <Modal
                centered
                show={visible}>
                <Modal.Header>
                    <Modal.Title>{title ? title : 'User Removal Confirmation'}</Modal.Title>
                </Modal.Header>
                {
                    loading ?
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 10 }}>
                            <Spinner animation='border' color='green' />
                        </div>
                        :
                        <>
                            <Modal.Body>
                                {
                                    msg ? msg : 'Do you want to remove users?'
                                }

                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    onClick={HideModal}
                                    className='btn btn-danger'>
                                    Cancel
                                </button>
                                <button
                                    onClick={()=>onButtonClick(1)}
                                    className='btn btn-primary'>
                                    Yes
                                </button>
                                <button
                                    onClick={()=>onButtonClick(0)}
                                    className='btn btn-success'>
                                    No
                                </button>

                               
                            </Modal.Footer>
                        </>
                }
            </Modal>
        </>
    )
}

export default RemoveUserModal